import React, { useEffect, useRef } from 'react';
import styles from "./PartnersDisplay.module.css";
import { Partner } from './Partner';
import partnerImage1 from "../../assets/partnersImages/partner.webp";

const partners: Partner[] = [
  { name: "Partner #1", logo: partnerImage1 },
  { name: "Partner #2", logo: partnerImage1 },
  { name: "Partner #3", logo: partnerImage1 },
  { name: "Partner #4", logo: partnerImage1 },
  { name: "Partner #5", logo: partnerImage1 },
  { name: "Partner #6", logo: partnerImage1 },
  { name: "Partner #7", logo: partnerImage1 },
  { name: "Partner #8", logo: partnerImage1 },
];

const PartnersDisplay: React.FC = () => {
  const imageRefs = useRef<(HTMLImageElement | null)[]>([]);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const img = entry.target as HTMLImageElement;
                    img.src = img.dataset.src!;
                    observer.unobserve(img);
                }
            });
        });

        imageRefs.current.forEach((img) => {
            if (img) {
                observer.observe(img);
            }
        });

        return () => {
            observer.disconnect();
        };
    }, []);

  return (
        <div className={styles.partnersGrid}>
          {partners.map((partner, index) => (
            <div
              key={index}
              className={styles.partnerCard}
              style={{
                animationDelay: `${index * 0.2}s`,
                animationDuration: `${4 + Math.random() * 2}s`,
              }}
            >
              <div className={styles.cardInner}>
                <div className={styles.logoWrapper}>
                  <img
                    ref={(el) => {
                      if (el) {
                        imageRefs.current[index] = el;
                      }
                    }}
                    src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                    data-src={partner.logo}
                    alt={partner.name}
                    className={styles.logo}
                  />
                </div>
                <div className={styles.partnerName}>{partner.name}</div>
              </div>
            </div>
          ))}
        </div>
  );
};

export default PartnersDisplay;
